module.exports = __webpack_public_path__ + "media/images/inbox-icon-c31acbf706c37939e41187a2e352b6d8.png";